import React from "react";
import CardMeta from "semantic-ui-react/dist/es/views/Card/CardMeta";

const VmoCardMeta = (props) => {
  return <CardMeta {...props}>{props.children}</CardMeta>;
};
export default VmoCardMeta;
